export class AwsRdsResourceAurora {
    'globalDbRole';
    'replicationSourceArn';
    'globalClusterIdentifier';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "globalDbRole",
            "baseName": "globalDbRole",
            "type": "string",
            "format": ""
        },
        {
            "name": "replicationSourceArn",
            "baseName": "replicationSourceArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "globalClusterIdentifier",
            "baseName": "globalClusterIdentifier",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRdsResourceAurora.attributeTypeMap;
    }
    constructor() {
    }
}
